import { render, staticRenderFns } from "./CertificationTask.vue?vue&type=template&id=9f896102&scoped=true&"
import script from "./CertificationTask.vue?vue&type=script&lang=js&"
export * from "./CertificationTask.vue?vue&type=script&lang=js&"
import style0 from "./CertificationTask.vue?vue&type=style&index=0&id=9f896102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f896102",
  null
  
)

export default component.exports